module.exports = __webpack_public_path__ + "static/media/dropoff.af94d884.svg";